import { apiRequest, createAntdFilter } from "@vojomo-core/shared";
import BaseLayout from "../../layouts/BaseLayout";
import { useEffect, useState } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";

// async function updatePrompt(
//   promptName: string,
//   newData: { available_tools: any; available_to_modus: any }
// ) {
//   await apiRequest({
//     subRoute: "admin",
//     path: "/update_pl_prompt",
//     method: "PATCH",
//     body: {
//       prompt_name: promptName,
//       available_tools: newData.available_tools,
//       available_to_modus: newData.available_to_modus,
//     },
//   });
// }

interface DataType {
  folder_name: string;
  url: string;
  href: string;
  label: string;
  system_prompt: string;
  model_info: string;
  model_params: string;
  available_tools: string;
  available_to_modus: boolean;
}

export const ModusConfig = () => {
  const [modusConfigData, setModusConfigData] = useState<any>({
    dataSource: []
  });

  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    const data = await apiRequest({
      subRoute: "admin",
      path: "/get_pl_data_dict",
      method: "GET"
    });

    if (typeof data === "object") {
      setModusConfigData(data);
    }
    setLoading(false);
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Folder Name",
      dataIndex: "folder_name",
      key: "folder_name",
      ...createAntdFilter("folder_name", "Folder Name"),
      sorter: (a: any, b: any) => a.folder_name.localeCompare(b.folder_name)
    },
    {
      title: "Name",
      dataIndex: "label",
      key: "label",
      ...createAntdFilter<DataType>("label", "Name"),
      sorter: (a: any, b: any) => a.label.localeCompare(b.label),
      render: (_: any, record: any) => (
        <a href={record.href} target="_blank">
          {record.label}
        </a>
      )
    }
    // {
    //   title: "System Prompt",
    //   dataIndex: "system_prompt",
    //   key: "system_prompt",
    //   ...createAntdFilter<DataType>("system_prompt", "System Prompt"),
    //   sorter: (a: any, b: any) =>
    //     a.system_prompt.localeCompare(b.system_prompt),
    // },
    // {
    //   title: "Available to Modus",
    //   dataIndex: "available_to_modus",
    //   key: "available_to_modus",
    //   ...createAntdFilter<DataType>("available_to_modus", "Available to Modus"),
    //   render: (_: any, record: any) => (
    //     <Checkbox
    //       checked={record.available_to_modus === "True"}
    //       onChange={(e) => {
    //         const newValue = e.target.checked;
    //         updatePrompt(record.label, {
    //           available_tools: record.available_tools,
    //           available_to_modus: newValue,
    //         });
    //         setModusConfigData((prevData: any) => ({
    //           ...prevData,
    //           dataSource: prevData.dataSource.map((item: any) =>
    //             item.label === record.label
    //               ? { ...item, available_to_modus: newValue ? "True" : "False" }
    //               : item
    //           ),
    //         }));
    //       }}
    //     />
    //   ),
    // },
  ];

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <BaseLayout pageTitle="Modus Config">
      <h3>Modus Config</h3>

      {loading ? (
        <></>
      ) : (
        <div style={{ maxHeight: "75vh", overflowY: "hidden" }}>
          <Table
            pagination={{ pageSize: 20 }}
            scroll={{ y: "60vh" }}
            columns={columns}
            dataSource={modusConfigData.dataSource.map(
              ({
                folder_name,
                label,
                system_prompt,
                available_to_modus,
                href
              }) => ({
                key: label,
                folder_name,
                label,
                system_prompt,
                available_to_modus,
                href
              })
            )}
          />
        </div>
      )}
    </BaseLayout>
  );
};
